// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"3524":"app","5203":"component---src-templates-feature-single-js"}[chunkId] || chunkId) + "." + {"3524":"094dac9455b37e257982","4120":"10ce2bdb4c854c95a31d","5203":"2d765f5687d3d6277deb"}[chunkId] + ".css";
};